import { CredentialStatus } from './credentialStatus';
import { CustomCredentialStatusDefinition } from './CustomCredentialStatusDefinition';
import { EntityCredentialSpecialty } from './entityCredentialSpecialty';

export class EntityCredential {
  public isActiveStatus: boolean;

  constructor(
    public id: string,
    /** format YYYY-MM-DD */
    public credentialStartDate: string,
    /** format YYYY-MM-DD */
    public credentialEndDate: string,
    public status: CredentialStatus,
    public credentialDefinitionId: string,
    public credentialName: string,
    public credentialNumber: string,
    public customCredentialStatusDefinition: CustomCredentialStatusDefinition,
    public isRenewalAvailable: boolean,
    public isReinstatementAvailable: boolean,
    public specialties: EntityCredentialSpecialty[]
  ) {
    this.id = id;
    this.credentialStartDate = credentialStartDate;
    this.credentialEndDate = credentialEndDate;
    this.status = status;
    this.credentialDefinitionId = credentialDefinitionId;
    this.credentialName = credentialName;
    this.credentialNumber = credentialNumber;
    this.customCredentialStatusDefinition = customCredentialStatusDefinition;
    this.isActiveStatus = [CredentialStatus.Active, CredentialStatus.ActiveRenewalPeriod].includes(
      status
    );
    this.isRenewalAvailable = isRenewalAvailable;
    this.isReinstatementAvailable = isReinstatementAvailable;
  }

  static parseMany(objs: any[]): EntityCredential[] {
    return objs.map((entityCredential) => EntityCredential.parse(entityCredential));
  }
  static parse(obj: any): EntityCredential {
    let credentialStatus =
      typeof obj.status === 'number'
        ? CredentialStatus[obj.status]
        : (obj.status as keyof typeof CredentialStatus);
    return new EntityCredential(
      obj.id,
      obj.credentialStartDate,
      obj.credentialEndDate,
      CredentialStatus[credentialStatus],
      obj.credentialDefinitionId,
      obj.credentialName,
      obj.credentialNumber,
      obj.customCredentialStatusDefinition,
      obj.isRenewalAvailable,
      obj.isReinstatementAvailable,
      obj.specialties || []
    );
  }
}
